import type { CustomAgentRunStatus } from '@axilon-apps/domains-ontology-ui-state'

import type { Status } from '../components/primitives/types'

const RUN_STATUS_MAP: Record<CustomAgentRunStatus, Status> = {
  pending_dispatch: 'idle',
  running: 'info',
  completed: 'run',
  failed: 'down',
  cancelled: 'idle'
}

/** Shared run-state → StatusPill tone. Configure and the run page both use this. */
export function runStateToStatus(state: string): Status {
  return RUN_STATUS_MAP[state as CustomAgentRunStatus] ?? 'idle'
}
